const dialogContentText = {
  styleOverrides: {
    root: ({ theme }: { theme: any }) => ({
      fontSize: theme.typography.body2.fontSize,
      lineHeight: theme.typography.body2.lineHeight,
      color: theme.palette.text.secondary,
    }),
  },
};

export default dialogContentText;
